import React, { useState } from "react"
import { Link } from 'gatsby'

import Collapsible from 'react-collapsible'

import styles from './styles/sidebar.module.css'


function Sidebar({ docs, expandedList }) {
  // Build initial state for sidebar
  const initialState = () => {
    if (expandedList === undefined || expandedList === null) {
      // On first load build an array of false values equalling the number of parent items in the sidebar.
      const arraySize = docs.length
      var initialArray = []
      for (var i = 0; i < arraySize; i++) {
        initialArray.push(false)
      }
      return initialArray
    } else {
      return expandedList
    }
  }

  const [isExpanded, setIsExanded] = useState(initialState)

  function clickHandler(index) {
    var tmpArray = isExpanded
    tmpArray[index] = !tmpArray[index]
    setIsExanded(tmpArray)
  }

  const sidebarList = docs.map((doc, index) => {
    var result;
    if (doc.items === null) {
      // If an item in the sidebar doesn't have any child links 
      // then we don't need to make it collapsible.
      result = (
        <ul className={styles.sidebarList} key={doc.id}>
          <li className={styles.sidebarHeading}><Link activeClassName={styles.sidebarActiveLink} className={styles.sidebarLink} state={isExpanded} to={doc.link}>{doc.title}</Link></li>
        </ul>
      )
    } else {
      result = (
        <ul className={styles.sidebarList} key={doc.id}>
          <Collapsible open={isExpanded[index]} trigger={<li className={styles.sidebarHeading} onClick={() => clickHandler(index)}>{doc.title}</li>}>
            <ul className={styles.sidebarList}>
              {doc.items.map((item, index) => (
                <li className={styles.sidebarSubheading} key={index}><Link activeClassName={styles.sidebarActiveLink} className={styles.sidebarLink} state={isExpanded} to={item.link}>{item.title}</Link></li>
              ))}
            </ul>
        </Collapsible> 
      </ul>
      )
    }
    return result
  })
  return (
    <aside className={styles.sidebar}>
      {sidebarList}
    </aside>
  )
}

export default Sidebar